import * as React from 'react';

import styled from '@emotion/styled';

const Svg = styled.svg`
  width: 25.003px;
  height: 25.001px;
  margin-right: 0.5rem;
`;

const OSIcon = () => {
  return (
      <Svg xmlns="http://www.w3.org/2000/svg">
          <path d="M12.5 0A12.5 12.5 0 1025 12.5 12.516 12.516 0 0012.5 0zm0 22.742a10.241 10.241 0 1110.243-10.241A10.252 10.252 0 0112.5 22.742z" fill="#2583c6" />
          <path d="M8.967 8.677a3.99 3.99 0 00-1.568.289 2.823 2.823 0 00-.941.655 3.429 3.429 0 00-.678 1 4.632 4.632 0 00-.333 1.866 3.757 3.757 0 00.959 2.729 3.426 3.426 0 002.582.99 3.387 3.387 0 002.561-1 4.456 4.456 0 00-.007-5.533 3.419 3.419 0 00-2.575-.996zm1.457 5.638a1.844 1.844 0 01-1.443.634 1.863 1.863 0 01-1.45-.638 3.408 3.408 0 01-.015-3.753 2.032 2.032 0 012.922-.008 2.737 2.737 0 01.548 1.868 2.78 2.78 0 01-.561 1.897zm7.682-2.252a7.269 7.269 0 00-1.586-.524 3.851 3.851 0 01-1.35-.485.563.563 0 01-.219-.443.529.529 0 01.233-.451 1.676 1.676 0 011-.264 1.471 1.471 0 01.93.246 1.245 1.245 0 01.406.807l1.469-.066a2.122 2.122 0 00-.726-1.6 3.077 3.077 0 00-2.063-.6 3.627 3.627 0 00-1.433.254 1.977 1.977 0 00-.909.737 1.913 1.913 0 00.356 2.5 3.972 3.972 0 001.659.721c.612.151 1 .258 1.176.318a1.218 1.218 0 01.529.315.664.664 0 01.151.44.9.9 0 01-.359.7 1.643 1.643 0 01-1.071.3 1.584 1.584 0 01-1.064-.337 1.745 1.745 0 01-.524-1.057l-1.429.139a2.774 2.774 0 00.883 1.86 3.153 3.153 0 002.121.637 4.118 4.118 0 001.583-.265 2.08 2.08 0 00.983-.812 2.141 2.141 0 00.348-1.172 2.17 2.17 0 00-.29-1.159 2.053 2.053 0 00-.804-.739z" fill="#2583c6" />
      </Svg>
  );
};

export default OSIcon;
